/* eslint-disable @typescript-eslint/prefer-optional-chain */
// 检测设备信息

import { SSO_DEVICE_INFO_KEY } from '@/utils/consant';
import { ssoLocalStorage } from './storage';
import Cookies, { setCookie } from '@/utils/cookie';
import { getBrowserVersion } from '@/utils/browser';

const isChrome = navigator.userAgent.indexOf('Chrome') > -1;

const collectDeviceInfo = () => {
  try {
    // 只在Chrome内核收集，目前相关API只支持Chrome内核
    if (!isChrome) return;
    // @ts-ignore
    if (navigator && navigator.userAgentData && navigator.userAgentData.getHighEntropyValues) {
      // @ts-ignore
      navigator.userAgentData.getHighEntropyValues(['platformVersion']).then((values) => {
        if (values) {
          const { platformVersion, platform } = values || {};
          ssoLocalStorage.setItem(SSO_DEVICE_INFO_KEY, JSON.stringify({ platformVersion, platform }));
          return { platformVersion, platform };
        }
      });
    }
  } catch (error) {
    //
  }
  return {};
};
collectDeviceInfo();

export const getDeviceInfo = () => {
  try {
    const deviceInfo = ssoLocalStorage.getItem(SSO_DEVICE_INFO_KEY);
    if (deviceInfo) {
      return JSON.parse(deviceInfo);
    }
  } catch (error) {
    return null;
  }
};

/**
 * @description: 获取webDeviceUuid
 * @return {*}
 */
export const collectUUIdPromise = () => new Promise((resolve) => {
  if (!window.LXAnalytics) {
    resolve('');
    return;
  }
  setTimeout(() => {
    resolve('');
  }, 5000);
  window?.LXAnalytics('get', 'lxcuid', (data) => {
    const browserInfo = getBrowserVersion();
    const opt: Cookies.CookieAttributes = {
      path: '/',
      Secure: false,
    };
    const isHttps = window.location.protocol.match(/^https/);
    if (isHttps) {
      opt.Secure = true;
    }
    // 许多现代浏览器支持 SameSite 属性。以下是一些常见浏览器及其支持情况：
    // Chrome：从 76 版本开始。
    // Firefox：从 63 版本开始。
    // Safari：从 13 版本开始。
    // Edge：从 79 版本（基于 Chromium）开始。
    // Internet Explorer：不支持 SameSite。
    if (isHttps && (browserInfo?.chrome >= 80 || browserInfo?.firefox >= 63 || browserInfo?.safari >= 13)) {
      opt.sameSite = 'None';
    }
    // 后端调yoda必须要这个参数
    setCookie('captchaId', data, opt);
    // 种到cookie即可,后端自动获取,无需上报
    resolve(data);
  });
});
